import { EngineConfigResponseSchema, type EngineConfigResponse } from '../schemas/quote.js';
import type { RequestOptions, Transport } from './transport.js';

export interface EngineClient {
  getConfig(options?: RequestOptions): Promise<EngineConfigResponse>;
}

export const createEngineClient = (transport: Transport): EngineClient => ({
  getConfig: (options) => transport.get('/engine/config', EngineConfigResponseSchema, options),
});

export type { EngineConfigResponse };
